const entityTypes = [
  'ACCOUNT',
  'ACCOUNT_CATEGORY',
  'ACCOUNT_GROUP',
  'ACCOUNTING_JOB',
  'ACCOUNT_PRIMARY',
  'AGREEMENT',
  'AMOUNT',
  'APPLICATION',
  'APPLICATION_TO_APPLICATION',
  'APPLICATION_COMMENT',
  'APPLICATION_SCHEME',
  'BALANCE',
  'BENEFICIARY',
  'BENEFICIARY_CONTRACT',
  'BLACKLIST',
  'BLACKLIST_DATA',
  'BLACKLIST_SETTING',
  'BUSINESS_PARTNER',
  'BUSINESS_PROFILE',
  'CLIENT_ACTIVITY',
  'CLIENT_BLACKLIST_QUEUE_ITEM',
  'CLIENT_SCHEME',
  'CLIENT_SCORE_ITEM',
  'CLIENT_SCORE_RESULT',
  'CHANNEL',
  'COUNTRY',
  'CURRENCY',
  'DEFAULT_MARGIN',
  'DELIVERY_CHANNEL',
  'DOCUMENT',
  'DOCUMENT_CATEGORY',
  'DOCUMENT_COMMENT',
  'EMPLOYEE',
  'EMPLOYEE_PERMISSION',
  'EMPLOYEE_ROLE',
  'EXCHANGE_AUTO_RULE',
  'EXCHANGE_CUSTOM_RATE_RULE',
  'EXPORT_BATCH',
  'FACTOR',
  'FEE',
  'GENERAL_LEDGER_QUEUE_ITEM',
  'GENERAL_LEDGER_TRANSACTION',
  'ID_DOC',
  'INCORPORATION_DATE',
  'ISSUE',
  'ISSUE_COMMENT',
  'LOCK',
  'MARGIN',
  'MESSAGE',
  'MONITORING_RULE',
  'NOTIFICATION',
  'OFFICIALS',
  'ORGANIZATION',
  'ORGANIZATION_COMMENT',
  'PAYMENT_ON_TRANSACTION_TYPE',
  'PAYMENT_ORDER',
  'PAYMENT_ORDER_BENEFICIARY',
  'PAYMENT_ORDER_STATE',
  'PRODUCT',
  'PROFILE',
  'PSP_ACCOUNT',
  'PSP_ACCOUNT_CATEGORY',
  'PSP_INTEGRATION',
  'PSP_INTEGRATION_PAYMENT',
  'PSP_INTEGRATION_PAYMENT_PARTNER',
  'PSP_INTEGRATION_PAYMENT_CURRENCY',
  'PSP_INTEGRATION_CONNECTION',
  'PSP_INTEGRATION_ACCOUNT',
  'PSP_PARTNER',
  'PSP_PARTNER_VISIBILITY',
  'PSP_INTEGRATION_PAYMENT_ACCOUNT',
  'RANGE',
  'RATE',
  'RATE_SOURCE',
  'RISK_SCORE_RANGE',
  'SCORE_RESULT',
  'SETTING',
  'SIC_CODE',
  'SIGNATURE',
  'SOURCES_OF_FOUNDS',
  'STATEMENT_ITEM',
  'STATEMENT_QUEUE',
  'SUM_SUB_APPLICATION',
  'SUPPORTING_DOCUMENT',
  'TARIFF',
  'TRANSACTION',
  'TRANSACTION_BLACKLIST_QUEUE_ITEM',
  'TRANSACTION_COMMENT',
  'TRANSACTION_RISK_SCORE_RANGE',
  'TRANSACTION_RULE',
  'TRANSACTION_SCORE_QUEUE_ITEM',
  'TRANSACTION_STATE',
  'TRANSACTION_TYPE',
  'TRANSACTION_QUEUE_ITEM',
  'TRANSACTION_VOLUME',
  'TRANSACTIONS_CONTRACTS',
  'QUESTIONNAIRE',
  'USER',
  'WARNING',
  'WARNING_GROUP',
];

export default entityTypes;
